import { render, staticRenderFns } from "./JumentsNonSuivies.vue?vue&type=template&id=27fbdb12&"
import script from "./JumentsNonSuivies.vue?vue&type=script&lang=js&"
export * from "./JumentsNonSuivies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports